'use strict';

function LegalDisclaimer() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [];
  this.url = '/legal.json';

  // List of Computed Variables added
  this.computedVar = [];

  // Default Calculation for Legal Disclaimer
  this.requiredModel = ['account.province'];
  this.provinceOverride = null; // Override for when requiredModel is empty
  this.computedVal = function (province, val, val2) {
    if (this.provinceOverride) {
      province = this.provinceOverride;
    }

    var result = val[province] || val.default;
    if (val2) {
      result += ' ' + val2[province] || val2.default;
    }
    return result;
  }.bind(this);

  // Expected Parameters for the Legal Disclaimer
  this.legal = null; // elements with legal
  this.otherLegal = null; // other legal without superscript
  this.presenter = null;
  this.showCta = false;

  this.itemContainer = null;
  this.itemClasses = '';

  this.init = function () {
    this._loadModel();
  };

  this.initAllReady = function () {};

  this._loadModel = function () {
    var _this = this;

    if (!this.presenter.models.disclaimer) {
      var contentfulPromise = $.Deferred();

      var contentful = new StaticContentful(_ContentfulConfiguration, $.extend({}, ContentfulAppSpaceParams, {
        verboseLevel: 2
      }));
      contentful.getResource('ENTRIES_FROM_MODEL', { model_id: 'legalDisclaimer' }, contentfulPromise.resolve.bind(this));

      this.presenter.createModel('disclaimer', { data: { _promise: contentfulPromise } });

      $.when(contentfulPromise).done(this._populateModel.bind(this)).fail(function () {
        console.error('LegalDisclaimer._loadModel failed to fetch data from:', legalJsonUrl);
      });
    } else if (this.presenter.models.disclaimer._promise) {
      this.presenter.models.disclaimer._promise.done(function () {
        _this.redraw();
      });
    } else {
      this.redraw();
    }
  };

  this._populateModel = function (contentfulData) {
    var _this2 = this;

    this.presenter.setModelProperty('disclaimer._promise', false);
    contentfulData.items.forEach(function (item) {
      if (!_this2.presenter.getModelProperty('disclaimer.' + item.key)) {
        _this2.presenter.setModelProperty('disclaimer.' + item.key, {});
      }
      _this2.presenter.setModelProperty('disclaimer.' + item.key + '.' + item.province, item.disclaimerCopy);
    });
    this.redraw();
  };

  this._buildLegal = function () {
    this.computedVar = [];

    if (this.legal) {
      var ol = this.result.find('ol');
      var dataLegal = Array.from(new Set(this.legal.map(function () {
        return $(this).data('legal');
      }).toArray()));

      // If the legalContainer parameter has been defined, then run different code, becuase it's probably for marketing
      if (this.itemContainer !== null) {
        ol = this.result;

        // This loops over all of the defined footnotes within the document
        $('sup[data-footnote]').each(function () {
          var currentValue = $(this).data('footnote');

          // Adds the footnote to the array in order if is not empty and not a duplicate
          if (currentValue && dataLegal.indexOf(currentValue) < 0) {
            dataLegal.push(currentValue);
          }

          // Inserts the current footnote number into the <sup /> element
          $(this).text(dataLegal.indexOf(currentValue) + 1);
        });
      }

      $.each(dataLegal, $.proxy(function (count, attr) {
        // only visible data-legal elements
        var element = $('[data-legal=\'' + attr + '\']:not([data-legal-superscript-disabled=\'true\'])');
        var item = this._buildDisclamerItem($('<li />'), attr);
        item.addClass(this.itemClasses);
        ol.append(item);

        this._addSuperscript(element, count + 1);
      }, this));
    }

    if (this.otherLegal) {
      var container = this.result.find('ul');

      if (this.itemContainer !== null) {
        container = this.result;
      }

      for (var i = 0; i < this.otherLegal.length; i++) {
        var item = this._buildDisclamerItem($('<li />'), this.otherLegal[i]);
        item.addClass(this.itemClasses);

        container.append(item);
      }

      this.result.prepend(container);
    }
  };

  this.redraw = function () {
    if (this.legal) {
      this.legal = $(this.legal.selector, this.legal.context); // requery the selector
      $('sup.legal-disclaimer__sup').remove();
      if (this.result && this.result.length) this.result.remove();
      this._clearComputedVariables();
    }
    this._draw();
  };

  this._draw = function () {
    this.result = $('<div><ul></ul><ol></ol></div>');

    if (this.itemContainer !== null) {
      this.result = $(this.itemContainer);
    } else {
      $(this.node).addClass('LegalDisclaimer');
    }

    $(this.node).append(this.result).show();

    this._buildLegal();
    this._showCTA();

    this.presenter.scanDOM(this.node);
  };

  this._showCTA = function () {
    var cta = $("<div class='legal-disclaimer__cta text-center'>" + "<a href='/privacy-and-security-policy' class='link'>Privacy & Security Policy</a> - " + "<a href='/terms-and-conditions' class='link'>Terms & Conditions</a>" + '</div>');

    if (this.showCta) {
      this.result.append(cta);
    }
  };

  this._buildDisclamerItem = function (item, legal) {
    var dataBind = 'legal-disclaimer-' + legal.replace('.', '-');
    var bindVars = [legal];
    this.computedVar.push(dataBind);
    this.presenter.addComputedVariable(dataBind, $.merge($.merge([], this.requiredModel), bindVars), this.computedVal);

    return item.attr('data-bind', dataBind);
  };

  this._addSuperscript = function (element, number) {
    var sup = $("<sup class='legal-disclaimer__sup'></sup>").text(number);
    element.append(sup);
  };

  this._clearComputedVariables = function () {
    // clean up all the computed variables that were added
    $.each(this.computedVar, $.proxy(function (i, v) {
      this.presenter.removeComputedVariable(v);
    }, this));
  };

  this.destroy = function () {
    this._clearComputedVariables();
  };
}